var _defs, _circle, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconSustainability(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_74_2",
    "data-name": "Component 74 \\u2013 2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #7bb6c6;\n      }\n\n      .cls-2 {\n        fill: #043f5d;\n        opacity: 0;\n      }\n\n      .cls-3 {\n        fill: #fff;\n      }\n    "))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_54",
    "data-name": "Ellipse 54",
    className: "cls-1",
    cx: 21,
    cy: 21,
    r: 21
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1246",
    "data-name": "Group 1246",
    transform: "translate(-1481 -9262.391)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_144",
    "data-name": "Ellipse 144",
    className: "cls-2",
    cx: 21,
    cy: 21,
    r: 21,
    transform: "translate(1481 9262.391)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1245",
    "data-name": "Group 1245",
    transform: "translate(461.864 8569.196)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1300",
    "data-name": "Path 1300",
    className: "cls-3",
    d: "M1035.269,725.45h8.4a6.231,6.231,0,0,0,3.28-.932c2.939-1.816,8.9-5.444,10.146-6.273,1.272-.848-.565-2.967-3.39-1.836a56.558,56.558,0,0,0-6.725,3.479,2.235,2.235,0,0,1-1.2.322l-6.027-.115a.147.147,0,0,1-.056-.281,45.734,45.734,0,0,1,4.613-1.71c2.061-.606,3.03-2.513,2.593-3.711a.663.663,0,0,0-.777-.42l-6.9,1.666a7.336,7.336,0,0,1-1.722.2h-5.439a6.469,6.469,0,0,0-4.707,2.261l-3.221,4.585,5.623,6.152,2.684-2.4A5.361,5.361,0,0,1,1035.269,725.45Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1244",
    "data-name": "Group 1244"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1301",
    "data-name": "Path 1301",
    className: "cls-3",
    d: "M1042.036,711.515a7.107,7.107,0,0,1,1.992-6.245c2.76-2.571,7.81-2.629,7.81-2.629s-.207,5.555-3.145,7.51A10.42,10.42,0,0,1,1042.036,711.515Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1302",
    "data-name": "Path 1302",
    className: "cls-3",
    d: "M1040.889,705.793a4.977,4.977,0,0,1-3.192-3.3c-.671-2.555.966-5.69.966-5.69s3.359,1.97,3.591,4.43A7.3,7.3,0,0,1,1040.889,705.793Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1303",
    "data-name": "Path 1303",
    className: "cls-3",
    d: "M1039.176,713.63a7.108,7.108,0,0,0-.561-6.532c-2.123-3.118-7.034-4.292-7.034-4.292s-1.028,5.463,1.4,8.02A10.42,10.42,0,0,0,1039.176,713.63Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSustainability);
export default __webpack_public_path__ + "static/media/icon-sustainability.da9386165213fb7617b2809aa74a27a1.svg";
export { ForwardRef as ReactComponent };